import { SeekPassIconVerified } from '@seek/certsy-ui';
import { useTranslations } from '@vocab/react';
import { Box, Text, Strong, TextLink, Bleed } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';

export const CertsyFooter = () => {
  const { t } = useTranslations(translations);

  return (
    <Box marginTop="xxlarge" paddingTop="large">
      <Bleed bottom="small">
        <Text
          size="xsmall"
          tone="secondary"
          data={{ automation: 'certsy-footer' }}
        >
          <SeekPassIconVerified />{' '}
          {t(
            'SEEK Pass verified - SEEK Pass is a secure and trusted way to verify...',
            { Strong: (v) => <Strong>{v}</Strong> },
          )}{' '}
          <TextLink
            href="https://seekpass.co?utm_source=seek&utm_medium=referral&utm_campaign=profile-shareable&utm_content=generic"
            target="_blank"
          >
            {t('Visit SEEK Pass')}
          </TextLink>
        </Text>
      </Bleed>
    </Box>
  );
};
